import React, { useEffect, useState } from "react";
import { Outlet, useParams } from "react-router-dom";

import { Auth, retrieveToken, retrieveTokenDev } from "@utils/auth/Auth";
import { type TokenData } from "@utils/auth/TokenStorage";
import { ContextProvider } from "./contextProvider/ContextProvider";

const PrivateRoute = (): React.JSX.Element | null => {
    const { userName } = useParams();
    const [tokenData, setTokenData] = useState<TokenData | null>(null);

    useEffect(() => {
        const controller = new AbortController();
        const { signal } = controller;

        const fetchToken = async (): Promise<void> => {
            try {
                let token: TokenData | null = null;
                if (userName && process.env.NODE_ENV !== "production") {
                    token = await retrieveTokenDev(0, userName, signal);
                } else if (process.env.NODE_ENV !== "production" && sessionStorage.getItem("devLogin") === "devLogin") {
                    token = await retrieveTokenDev(0, null, signal);
                } else {
                    token = await retrieveToken(signal);
                }

                if (!signal.aborted) {
                    setTokenData(token);
                }
            } catch (error) {
                if (!signal.aborted) {
                    console.error("Failed to retrieve token:", error);
                    setTokenData(null);
                }
            }
        };

        void fetchToken();

        return (): void => {
            controller.abort();
        };
    }, [userName]);

    if (!tokenData) {
        return null;
    }

    return (
        <ContextProvider initialState={{ token: tokenData.token, username: tokenData.username }}>
            <Outlet />
            <Auth />
        </ContextProvider>
    );
};

export default PrivateRoute;
